import getEnv from '@clearscore/helpers.envs';
import { selectors as marketSelectors } from '@clearscore/redux.market';
import { GLOBAL } from '@clearscore/config.i18n';

const customerOpsApiDomain = (state) => {
    const market = marketSelectors.getActiveMarket(state);
    const marketPrefix = market && market !== GLOBAL && `${market.toUpperCase()}_`;
    const apiDomainEnv = marketPrefix && `${marketPrefix}CUSTOMER_OPS_API_DOMAIN`;
    const apiDomain = apiDomainEnv && getEnv(apiDomainEnv);
    return apiDomain || getEnv('CUSTOMER_OPS_API_DOMAIN');
};

const adanaApiDomain = (state) => {
    const market = marketSelectors.getActiveMarket(state);
    const marketPostfix = market && market !== GLOBAL ? `_${market.toUpperCase()}` : '';
    return getEnv(`ADANA_API${marketPostfix}`);
};

const identityGatewayApiDomain = (state) => {
    const market = marketSelectors.getActiveMarket(state);
    const apiDomain = getEnv('IDENTITY_GATEWAY_API_DOMAIN') || '';

    // TODO: remove logic once generic, global domain is available
    return market !== GLOBAL ? apiDomain : apiDomain.replace('@market@', 'gb');
};

export default {
    media: {
        baseURL: getEnv('MEDIA_API_DOMAIN'),
        responseType: 'json',
    },
    caesium: {
        baseURL: getEnv('CAESIUM_API_DOMAIN'),
        responseType: 'json',
    },
    banking: {
        baseURL: getEnv('OB_API_DOMAIN'),
        responseType: 'json',
    },
    bankingTl: {
        baseURL: getEnv('OB_TL_API_DOMAIN'),
        responseType: 'json',
    },
    staticDescriptors: {
        baseURL: getEnv('STATIC_JSON_URL'),
        responseType: 'json',
    },
    international: {
        baseURL: getEnv('INTERNATIONAL_API_DOMAIN'),
        responseType: 'json',
    },
    flux: {
        baseURL: getEnv('FLUX_API_DOMAIN'),
        responseType: 'json',
    },
    okta: {
        baseURL: getEnv('OKTA_ISSUER'),
        responseType: 'json',
    },
    customerOps: {
        baseURL: customerOpsApiDomain,
        responseType: 'json',
    },
    customerOpsDocuments: {
        baseURL: customerOpsApiDomain,
        responseType: 'arraybuffer',
    },
    energyService: {
        baseURL: getEnv('SERVICE_ENDPOINT_ENERGY'),
        responseType: 'json',
    },
    gbService: {
        baseURL: getEnv('GB_SERVICE_DOMAIN'),
        responseType: 'json',
    },
    caesium_gb: {
        baseURL: getEnv('CAESIUM_GB_API_DOMAIN'),
        responseType: 'json',
    },
    caesium_za: {
        baseURL: getEnv('CAESIUM_ZA_API_DOMAIN'),
        responseType: 'json',
    },
    websiteCMS: {
        baseURL: getEnv('GLOBAL_WEBSITE_CMS_API'),
        responseType: 'json',
    },
    adana: {
        baseURL: adanaApiDomain,
        responseType: 'json',
    },
    partner: {
        baseURL: getEnv('PARTNER_API_DOMAIN'),
        responseType: 'json',
    },
    connect: {
        baseURL: getEnv('CONNECT_API_DOMAIN'),
        responseType: 'json',
    },
    connectUpload: {
        headers: {
            'Content-Disposition': 'attachment',
        },
    },
    uploadS3Policy: {
        headers: { 'Content-Type': 'multipart/form-data' },
        responseType: 'json',
    },
    products: {
        baseURL: getEnv('PRODUCTS_API_DOMAIN'),
        responseType: 'json',
    },
    renderEngine: {
        baseURL: getEnv('RENDER_ENGINE_API_DOMAIN'),
        responseType: 'json',
    },
    identityGateway: {
        baseURL: identityGatewayApiDomain,
        responseType: 'json',
    },
};
